import { motion } from "framer-motion";

export default function FeaturesAnimated() {
  const features = [
    "Real-time webcam capture with fast prediction feedback.",
    "A focused CNN recognition layer for sign classification.",
    "Sentence-building output for continuous interaction.",
    "Accessible product framing designed around clarity.",
  ];

  return (
    <section className="page-section">
      <div className="section-shell px-6">
        <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="eyebrow">Core Features</div>
            <h2 className="mt-5 max-w-2xl text-4xl text-stone-900 md:text-5xl">
              Built for demos, research, and human-readable output.
            </h2>
          </div>

          <p className="max-w-xl text-lg leading-8 text-stone-600">
            The interface now supports the project better: stronger hierarchy,
            clearer cards, and enough atmosphere to feel deliberate without
            getting in the way.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {features.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
              viewport={{ once: true, amount: 0.35 }}
              className="feature-tile content-card rounded-[1.75rem] p-6 text-left"
            >
              <p className="feature-number">0{i + 1}</p>

              <h3 className="mt-5 text-2xl font-bold text-stone-900">
                {
                  [
                    "Live Recognition",
                    "Model Pipeline",
                    "Sentence Assembly",
                    "Accessible UI",
                  ][i]
                }
              </h3>

              <p className="mt-4 max-w-xs text-base leading-7 text-stone-600">
                {f}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
